import { render, staticRenderFns } from "./upload2.vue?vue&type=template&id=327d46a8&scoped=true"
import script from "./upload2.vue?vue&type=script&lang=js"
export * from "./upload2.vue?vue&type=script&lang=js"
import style0 from "./upload2.vue?vue&type=style&index=0&id=327d46a8&prod&lang=css"
import style1 from "./upload2.vue?vue&type=style&index=1&id=327d46a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327d46a8",
  null
  
)

export default component.exports